import { Action } from "@/interface/action";

let initialState = {
  collapsed: false,
}

export const Config = (state = initialState, action: Action) => {
  switch (action.type) {
    case "TOGGLE_COLLAPSED":
      return {...state, collapsed: !state.collapsed };
    case "RESET":
      return initialState;
    default:
      // 默认情况下，返回当前状态，不做任何改变
      return state;
  }
}